import { Box, Grid2, Typography } from "@mui/material";
import { useBaseEntityInfo } from "../../Hooks/usePagesContent";

const MultipleEntityCurrentStatus = ({ entityStatusCounts }) => {

    const { baseEntityTypePluralLable } = useBaseEntityInfo();
    const {
        operational: operationalCount,
        non_operational: nonOperationalCount,
        not_set: notSetCount,
        total: totalCount
    } = entityStatusCounts;

    return (
        <Box sx={{ bgcolor: '#F9F9F9', borderRadius: 2, px: 2, py: 1.5, mb: 1 }}>
            <Grid2 container justifyContent={'space-between'} alignItems={'center'} mb={1}>
                <Typography variant="fw400s14c000000" sx={{ lineHeight: '24px', fontWeight: 500 }}> {baseEntityTypePluralLable} Selected</Typography>
                <Typography variant="fw400s14c000000" sx={{ lineHeight: '24px', fontWeight: 500 }}>{totalCount}</Typography>
            </Grid2>
            <Grid2 container justifyContent={'space-between'} alignItems={'center'} mb={0.5}>
                <Typography variant="fw400s14c000000" sx={{ lineHeight: '24px' }}>Operational</Typography>
                <Typography variant="fw400s14c000000" sx={{ lineHeight: '24px' }}>{operationalCount}</Typography>
            </Grid2>
            <Grid2 container justifyContent={'space-between'} alignItems={'center'} mb={0.5}>
                <Typography variant="fw400s14c000000" sx={{ lineHeight: '24px' }}>Non-Operational</Typography>
                <Typography variant="fw400s14c000000" sx={{ lineHeight: '24px' }}>{nonOperationalCount}</Typography>
            </Grid2>
            <Grid2 container justifyContent={'space-between'} alignItems={'center'} mb={0.5}>
                <Typography variant="fw400s14c000000" sx={{ lineHeight: '24px' }}>Not Set</Typography>
                <Typography variant="fw400s14c000000" sx={{ lineHeight: '24px' }}>{notSetCount}</Typography>
            </Grid2>
        </Box>
    )
}

export default MultipleEntityCurrentStatus;
